import {Timer} from 'components/common/Timer'
import {TrustBlock} from 'components/common/TrustBlock/TrustBlock'
import {CartItems} from './CartItems/CartItems'

export const Right = () => {
  return (
    <div className="w-full d:w-[386px] flex flex-col gap-6">
      <Timer />
      <CartItems />
      <div className="hidden d:block">
        <TrustBlock />
      </div>
    </div>
  )
}
